import React, {useEffect, useState, useContext} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Tabs, Button, Layout, Spin, Tag, InputNumber, Modal} from "antd";
import Summary from './Summary';
import Item from './Item';
import Risk from './Risk'
import ReportHeader from '../Common/ReportHeader';
import {getFindRiskStatistics, getPdfDownload, getEditDoa} from '../Common/api';
import DownloadUrl from '../../components/DownloadUrl';
import {DownloadMd} from '../../components/DownloadPdf';
import MarkdownViewer from '../../components/MarkdownViewer';
import AppContext from '../../components/AppContext';
import {useConfigValue} from '../ConfigValue/configData';
import Cookies from 'js-cookie';
// import html2pdf from 'html2pdf.js/dist/html2pdf.min'
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";

const {Content} = Layout;
const {TabPane} = Tabs;

/** -------------------------------------------------------------------------- **/
function RiskReport() {
    const params = useParams();
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);
    const myContext = useContext(AppContext);
    const {fetchAndUpdateConfig} = useConfigValue();
    // 변수 선언
    const reportId = params.reportId;
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [tabId, setTabId] = useState('1');
    const [reportInfo, setReportInfo] = useState({});
    const [doa, setDoa] = useState(12);

    const [isDataChange, setIsDataChange] = useState(false);
    const [spinflag,  setSpinflag] = useState(true);
    const [spinflagMain,  setSpinflagMain] = useState(false);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');
    const titleName = "위험관리";
    const searchValue = window.location.href.split('?')[1].split("=")[1];
    const [companyCode, setCompanyCode] = useState(searchValue ? searchValue : Cookies.get('auth_companyCode'));

    useEffect(() => {                       
        initDoa();
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
            setCompanyCode(companyCode);
            setAssetType(reportInfo.asset_type);
            setReportName(reportInfo.report_nm);     
        }
    }, [reportInfo]);

    const [itemList, setItemList] = useState([]);
    const [measureList, setMeasureList] = useState([]);
    const [riskScoreList, setRiskScoreList] = useState([]);
    const [riskGradeList, setRiskGradeList] = useState([]);
    const [riskDetailList, setRiskDetailList] = useState([]);

    const [sumData, setSumData] = useState({total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0});

    /** -------------------------------------------------------------------------- **/
    useEffect(() => {
        findReportList(reportId);
    }, [reportId]);

    useEffect(() => {
        
        let s_data = {total : 0, total_risk : 0, risk_rate : 0, H : 0, M : 0, L : 0, ManagedRisks : 0, UnmanagedRisks : 0, DoaCount:0, MLcount:0};
        measureList.map(curr => {
            s_data.total = (s_data.total + curr.total);
            s_data.total_risk = (s_data.total_risk + curr.total_risk);
            s_data.H = (s_data.H + curr.H);
            s_data.M = (s_data.M + curr.M);
            s_data.L = (s_data.L + curr.L);   
            s_data.DoaCount = (s_data.DoaCount + curr.DoA);
            // s_data.DoaCount = (s_data.DoaCount+curr.H);
            return s_data;
        });
        s_data.risk_rate = (s_data.total_risk /  s_data.total) * 100;
        s_data.ManagedRisks = s_data.H > 0 ? (s_data.DoaCount /  s_data.total_risk) * 100 : 0; 
        s_data.UnmanagedRisks = s_data.total_risk > 0 ? ( (s_data.total_risk -s_data.DoaCount) /  s_data.total_risk) * 100 : 0;
        
        setSumData(s_data);
      }, [measureList]);

    // 레포트 조회
    const findReportList = (reportId) => {       
        if(reportId) {
            //통계 조회
            axios.get(getFindRiskStatistics(reportId))
            .then((response) => {
                setItemList(response.data.statistic_root.sort((a, b) => 
                    a.measure_type.localeCompare(b.measure_type)
                ));

                for(let i=0; i<response.data.statistic_measure.length; i++){
                    response.data.statistic_measure[i].DoaCount=response.data.statistic_measure[i].DoA;
                }

                if(response.data.statistic_risk_detail.length > 0){
                    const detailList = response.data.statistic_risk_detail.map((item) => {
                        const assetKeys = Object.keys(item.asset_dict);
                        const assetValues = Object.values(item.asset_dict);

                        return {
                            ...item,
                            asset_cd: assetKeys.join(','),
                            score_value: assetValues.join(',')
                        };
                    });
                    setRiskDetailList(detailList);
                }else{
                    setRiskDetailList(response.data.statistic_risk_detail);
                }      
                setMeasureList(response.data.statistic_measure);
                setRiskScoreList(response.data.statistic_risk_score);
                setRiskGradeList(response.data.statistic_risk_grade);

            })
            .catch((error) => {                
                Modal.error({title:titleName, content:error.message, okText:"Close"});
            })
            .finally(() => {
                setSpinflag(false);
                setIsDataChange(false);
            });
        }
    }

    const initDoa = async () => {
        try {
            const configFlag = await fetchAndUpdateConfig(companyCode);
            if (!configFlag) {
                console.log("RiskReport fetch error.");
            }else{
                setDoa(configFlag.val_10);
            }
        } catch (error) {
            console.error("RiskReport error:", error);
        }
    };
    /** -------------------------------------------------------------------------- **/
    // 닫기
    const onClickCloseHandler = () => {
        window.close();
    }

    // 탭클릭
    const onChangeTabHandler = (key) => {
        //console.log(key);
        setTabId(key);
    };

    const pdfDownLoadReport = (event) =>{
        setSpinflagMain(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다...");
        let titleName="보고서 생성";
        
        const buttonType = event.currentTarget.textContent;

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("riskeval_md", reportId)).then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflagMain(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown 생성 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        }else{

            axios.get(getPdfDownload("riskeval", reportId)).then((response) => {
    
                if(response.data.status_url){
                    DownloadUrl(response.data.status_url,
                        () => setSpinflagMain(false), // onSuccess  
                        (errorMessage) => {
                            Modal.error({ title: errorMessage, okText: "Close" });
                            setSpinflagMain(false);
                        }
                    );
                }else{
                    Modal.error({ title: "다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                    setSpinflagMain(false);
                }
            }).catch((error) => {
                Modal.error({ title: "다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                setSpinflagMain(false);
            });      
        }        
    }
    
    const pdfDownload = () => {

        const report = document.getElementById('report');
        const data = document.getElementById('divTabs' + tabId);
        const div_height = data.style.height;
        data.style.height = (data.scrollHeight) + 'px';

        DownloadPdf(report, reportId, 'l');

        // html2canvas(report).then((canvas) => {
        // const margin = 6; // 출력 페이지 여백설정
        // const imgWidth = 198;  // 208
        // const pageHeight = 295;
        // const imgHeight = (canvas.height * imgWidth) / canvas.width;
        // let heightLeft = imgHeight;
        // let position = margin;
        // heightLeft -= pageHeight;
        // const doc = new jsPDF('p', 'mm', 'a4');
        // doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
        // while (heightLeft >= 0) {
        //     position = heightLeft - imgHeight;
        //     doc.addPage();
        //     doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
        //     heightLeft -= pageHeight;
        // }
        // doc.save('RiskReport_'+reportId+'.pdf');
        // });
        //높이 재조정
        data.style.height = div_height;
    };
    
    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findReportList(reportId);
        }
    }, [isDataChange]);

    const tabItems = [
        {
            label: '요약 및 그래프',
            key: '1',
            children: <Summary assetType={assetType} measureList={measureList} riskScoreList={riskScoreList} rowKey="id" sumData={sumData} spinflag={spinflag} />,
        },
        {
            label: '항목별 통계',
            key: '2',
            children: <Item reportId={reportId} itemList={itemList} rowKey="id" riskGradeList={riskGradeList} riskScoreList={riskScoreList} doa={doa} onChanggeAfter={(p_isChange) => { setIsDataChange(p_isChange); }} />,
        },
        {
            label: '위험 평가',
            key: '3',
            children: <Risk riskDetailList={riskDetailList} rowKey="measure_type" />,
        },
    ];
    
/** -------------------------------------------------------------------------- **/
    return (
        <Spin size={"large"}  tip={loadMessage} spinning={spinflagMain}>
        <Layout id="report" style={{overflow: 'hidden'}}>
            <div className='popup_header'>
                <div className='popup_title'>
                    위험평가 : 통계
                </div>
            </div>
            <div className="popup_button_report" style={{top:'10px'}}>
                {/* <Button
                        type="default"
                        onClick={pdfDownload}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'PDF Download'}
                </Button> */}
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'Markdown'}
                </Button>
                <Button
                    type="default"
                    onClick={pdfDownLoadReport}
                    style={{marginLeft: '10px'}}
                    data-html2canvas-ignore="true"
                >
                    {'보고서'}
                </Button>
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                    data-html2canvas-ignore="true"
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section" id="reportHeader">
                <ReportHeader reportId={reportId} reportInfo={reportInfo} setReportInfo={setReportInfo}/>
            </div>           
            <div className="sub_title" style={{position:"absolute", top:"135px", left:"380px", zIndex:99}}>
                    <span style={{ color: '#0378c7' }}>※ DOA 기준 :
                        &nbsp;&nbsp;
                        <Tag color={'volcano'}> {doa} </Tag> 이상
                    </span>
                </div>    
            <div className="section" style={{borderTop: '0'}}>                
                 <Content style={{ backgroundColor: '#f5f5f5'}}>
                    <Tabs defaultActiveKey="1" type={'card'} items={tabItems} destroyInactiveTabPane={false} />
                </Content>
            </div>
        </Layout>
        <MarkdownViewer 
            visible={markdownVisible}
            onClose={() => setMarkdownVisible(false)}
            markdownContent={markdownContent}
            reportId={reportId}
            reportName={reportInfo.report_nm || ''}
        />
        </Spin>
    );
}


export default RiskReport;